import {
  useExperimentValue,
  useFeatureFlag,
} from '@seek/candidate-feature-flag';

import { useCandidateDetails } from 'src/modules/hooks/useCandidateDetailsQuery.ts';

import { REFINE_BAR_V2_FEATURE_FLAG } from '../../config/featureFlags.ts';
import { useSelector } from '../react';

import { selectFeatureFlag } from './selectors';

export const useIsHomepageRecsBadgingStrongApplicantEnabled = () =>
  useSelector(selectFeatureFlag('homepageRecsBadgingStrongApplicant'));

export const useIsHomepageRecsBadgingExpiringSoonEarlyApplicantEnabled = () =>
  useSelector(
    selectFeatureFlag('homepageRecsBadgingExpiringSoonEarlyApplicant'),
  );

export const useIsHomepageGenAIChatEnabled = () => {
  const isHomepageGenAIChatEnabled = useSelector(
    selectFeatureFlag('homepageGenAIChat'),
  );

  const allowedList: number[] = [582665568, 18345529];
  const { id: seekerId } = useCandidateDetails();

  return (
    isHomepageGenAIChatEnabled ||
    Boolean(seekerId && allowedList.includes(seekerId))
  );
};

export const useIsHomepageGenAIChatAltModelEnabled = () =>
  useSelector(selectFeatureFlag('homepageGenAIChatAltModel'));

export const DynamicPillsV2 = 'dynamic-pills-v2';
export const StickySearchBar = 'sticky-search-bar';
export const RefineBarV2 = 'refine-bar-v2';
export type RefineBarV2Experiment =
  | typeof DynamicPillsV2
  | typeof StickySearchBar
  | typeof RefineBarV2;

export const useFeatureFlagRefineBarV2Experiment = () => {
  const value = useExperimentValue<RefineBarV2Experiment>(
    REFINE_BAR_V2_FEATURE_FLAG,
  );

  const dynamicPillsV2 = useSelector(selectFeatureFlag('dynamicPillsV2'));
  const stickySearchBar = useSelector(selectFeatureFlag('stickySearchBar'));
  const refineBarV2 = useSelector(selectFeatureFlag('refineBarV2'));

  return {
    dynamicPillsV2: dynamicPillsV2 || value === DynamicPillsV2,
    stickySearchBar: stickySearchBar || value === StickySearchBar,
    refineBarV2: refineBarV2 || value === RefineBarV2,
  };
};

// This is a temporary solution to get the feature flag value
// for the team to review the stages of our work internally
// while waiting Navi team to create an official LD switch
// which is scheduled to be completed by the end of next sprint.
export const useIsFeatureFlagEnabled = (
  key: string,
  flag: { isEnabled: boolean; variation: boolean },
) => {
  const value = useFeatureFlag(key);
  return flag.isEnabled || value === flag.variation;
};
